'use client'

import { faHeart } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  AnalyticsEntityType,
  AnalyticsSource,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

import { BaseCarousel } from '@/components/common/carousel/BaseCarousel'
import { InsideGroupWrapper } from '@/components/common/carousel/InsideGroupWrapper'
import { useListingSearch } from '@/components/listings/search/ListingSearchProvider'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

interface WatchlistCarouselProps {
  personId: string
  /** Set when a CMS row places this inside a carousel group, which supplies the padding itself. */
  insideGroup?: boolean
}

export default function WatchlistCarousel({
  personId,
  insideGroup = false,
}: WatchlistCarouselProps) {
  const { data, isLoading } = useListingSearch()
  const { track } = useAnalytics()

  const handleViewAllClick = () => {
    track('button_click', {
      button_name: 'carousel_view_all',
      carousel_name: 'watchlist',
      screen_name: 'homepage',
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
    })
  }

  const carousel = (
    <BaseCarousel
      data={data}
      isLoading={isLoading}
      title={<FormattedMessage id="Common.Carousel.watchlistTitle" />}
      icon={<FontAwesomeIcon icon={faHeart} />}
      viewMoreUrl={`/buy/p/${personId}/watchlist`}
      viewMoreText={
        <>
          <FormattedMessage id="Common.Carousel.viewAll" /> →
        </>
      }
      onViewAllClick={handleViewAllClick}
      carouselName="watchlist"
    />
  )

  return insideGroup ? (
    <InsideGroupWrapper>{carousel}</InsideGroupWrapper>
  ) : (
    carousel
  )
}
